import { c as _c } from "react-compiler-runtime";
import { useContext } from 'react';
// @ts-ignore untyped JS module
import formatName from '../utils/formatName';
// @ts-ignore untyped JS module
import formatFriendlyName from '../utils/formatFriendlyName';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
function FormattedName(t0) {
  const $ = _c(10);
  const {
    email,
    familyName,
    givenName,
    isFriendly: t1,
    name,
    options,
    titleType
  } = t0;
  const isFriendly = t1 === undefined ? false : t1;
  useContext(I18nHMRContext);
  let t2;
  if ($[0] !== email || $[1] !== familyName || $[2] !== givenName || $[3] !== isFriendly || $[4] !== name || $[5] !== options || $[6] !== titleType) {
    t2 = isFriendly ? formatFriendlyName({
      givenName,
      familyName,
      email
    }, options) : formatName({
      firstName: givenName,
      lastName: familyName,
      email,
      name,
      titleType
    }, options);
    $[0] = email;
    $[1] = familyName;
    $[2] = givenName;
    $[3] = isFriendly;
    $[4] = name;
    $[5] = options;
    $[6] = titleType;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const formattedName = t2;
  let t3;
  if ($[8] !== formattedName) {
    t3 = /*#__PURE__*/_jsx("span", {
      children: formattedName
    });
    $[8] = formattedName;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
FormattedName.displayName = 'FormattedName';
export default FormattedName;